import { useCallback } from 'react'
import { useTimer, TimerApi } from './Timer'

/* TYPES */

type Result = Promise<any> | boolean | undefined

interface DelayedCallbackConfig {
  after?: () => any
  before?: (event: any) => Result
  delay: number
  timer?: TimerApi
}

export const isPromise = (obj: any): obj is Promise<any> =>
  typeof obj === 'object' && typeof obj.then === 'function'

export const wrapPromise = (result: Result): Promise<any> => {
  if (isPromise(result)) {
    return result
  }

  if (typeof result === 'boolean') {
    return Promise.resolve(result)
  }

  return Promise.resolve(true)
}

/* HOOK */

export const useDelayedCallback = ({
  after = () => true,
  before = () => true,
  delay = 0,
  timer = useTimer({}),
}: DelayedCallbackConfig) => {
  const { setTimer } = timer

  return useCallback(
    (event: any) => {
      return wrapPromise(before(event)).then(
        (shouldUpdate: boolean) => shouldUpdate && setTimer(after, delay)
      )
    },
    [delay, after]
  )
}
